export default "__VITE_ASSET__C6mXN09A__"